<script lang="ts" setup>
import { cn } from "@/lib/utils";
import {
    CalendarCellTrigger,
    type CalendarCellTriggerProps,
    useForwardProps,
} from "radix-vue";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
    CalendarCellTriggerProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <CalendarCellTrigger
        :class="
            cn(
                'rounded-md text-sm ring-offset-white focus-visible:ring-stone-950 dark:ring-offset-stone-950 dark:focus-visible:ring-stone-300 inline-flex items-center justify-center transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50',
                'h-9 w-9 p-0 font-normal',
                '[&[data-today]:not([data-selected])]:bg-stone-100 [&[data-today]:not([data-selected])]:text-stone-900 dark:[&[data-today]:not([data-selected])]:bg-stone-800 dark:[&[data-today]:not([data-selected])]:text-stone-50',
                // Selected
                'data-[selected]:bg-stone-900 data-[selected]:text-stone-50 data-[selected]:hover:bg-stone-900 data-[selected]:hover:text-stone-50 data-[selected]:focus:bg-stone-900 data-[selected]:focus:text-stone-50 dark:data-[selected]:bg-stone-50 dark:data-[selected]:text-stone-900 dark:data-[selected]:hover:bg-stone-50 dark:data-[selected]:hover:text-stone-900 dark:data-[selected]:focus:bg-stone-50 dark:data-[selected]:focus:text-stone-900 data-[selected]:opacity-100',
                // Disabled
                'data-[disabled]:text-stone-500 dark:data-[disabled]:text-stone-400 data-[disabled]:opacity-50',
                // Unavailable
                'data-[unavailable]:text-stone-50 dark:data-[unavailable]:text-stone-50 data-[unavailable]:line-through',
                // Outside months
                'data-[outside-view]:text-stone-500 [&[data-outside-view][data-selected]]:bg-stone-100/50 [&[data-outside-view][data-selected]]:text-stone-500 dark:data-[outside-view]:text-stone-400 dark:[&[data-outside-view][data-selected]]:bg-stone-800/50 dark:[&[data-outside-view][data-selected]]:text-stone-400 data-[outside-view]:opacity-50 [&[data-outside-view][data-selected]]:opacity-30',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </CalendarCellTrigger>
</template>
